import { createContext } from 'react';

export interface ICalendarAppContext {
  goToCalendarApp: () => Promise<void>;
}

export const CalendarAppContext = createContext<ICalendarAppContext>(null!);
